module.exports = __webpack_public_path__ + "h5/img/invite-title.3b0c3c2b.png";